<template>
  <header-common 
    :theme=themeStr
  />
</template>
<script>
import HeaderCommon from './HeaderCommon'
export default {
  name: 'HeaderWhite',
  props: {
    },
  components: {
    'header-common': HeaderCommon
  },
  data() {
    return {
      themeStr: "white",
    };
  }
}
</script>
<style lang="scss" scoped>
.header__container {
  position: relative;
  // 映像変更後カラー削除
  background: #ffffff;
}

</style>